<disclaimer *ngIf="isViewMode" [message]="'LOCATION_SECTOR_DIALOG.DISCLAIMER.NO_EDIT' | translate"> </disclaimer>
<disclaimer *ngIf="!isViewMode" [message]="'LOCATION_SECTOR_DIALOG.DISCLAIMER.HELP' | translate"></disclaimer>

<fc-outlined-input
  [label]="'LOCATION_SECTOR_DIALOG.CONTROL.NAME' | translate"
  [control]="locationSectorForm.get('name')"
  [required]="true"
  [maxLength]="100"
>
  <ng-container *ngIf="locationSectorForm.get('name').hasError('required')">
    {{ 'LOCATION_SECTOR_DIALOG.CONTROL.ERRORS.NAME.REQUIRED' | translate }}
  </ng-container>
  <ng-container *ngIf="locationSectorForm.get('name').hasError('maxlength')">
    {{ 'LOCATION_SECTOR_DIALOG.CONTROL.ERRORS.NAME.MAX_LENGTH' | translate }}
  </ng-container>
  <ng-container *ngIf="locationSectorForm.get('name').hasError('nameAlreadyExists')">
    {{ 'LOCATION_SECTOR_DIALOG.CONTROL.ERRORS.NAME.DUPLICATED' | translate }}
  </ng-container>
</fc-outlined-input>

<fc-location-input
  [control]="locationSectorForm.get('location')"
  [requiredMark]="true"
  [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
></fc-location-input>

<fc-outlined-textarea
  [label]="'LOCATION_SECTOR_DIALOG.CONTROL.DESCRIPTION' | translate"
  [control]="locationSectorForm.controls.description"
  [hint]="2000"
>
  <ng-container *ngIf="locationSectorForm.get('description').hasError('maxlength')">
    {{ 'LOCATION_SECTOR_DIALOG.CONTROL.ERRORS.DESCRIPTION.MAX_LENGTH' | translate }}
  </ng-container>
</fc-outlined-textarea>
